module.exports = __webpack_public_path__ + "static_pc/img/ower01.bb08c9d6.png";